



















































































































import Super from "@/pv4-super-class"
import { Component, Prop, Watch } from "vue-property-decorator"

import { size } from "lodash"
import flatten from "flat"

@Component({
  components: { editor: require("vue2-ace-editor") }
})
export default class ScriptEditor extends Super {
  @Prop({ required: false, default: "" }) value: any
  @Prop({ required: false, type: String, default: "is-bottom-left" })
  position: any
  @Prop({ required: false, type: String }) language: any

  textValue: any = null
  lastAudition: any = null

  modalIsOpen = false

  @Watch("value")
  watchValue(newValue) {
    this.textValue = newValue
  }

  get iconForLanguage() {
    switch (this.language) {
      case "javascript":
        return "language-javascript"
        break

      default:
        return "code-braces-box"
        break
    }
  }

  mounted() {
    this.textValue = this.value
  }

  get debugLogs(): [] {
    if (!this.lastAudition || !this.lastAudition.log) return []
    return flatten(this.lastAudition.log)
  }

  get debugResult(): [] {
    if (!this.lastAudition || !this.lastAudition.result) return []
    return flatten(this.lastAudition.result)
  }

  get debugResultLength() {
    return size(this.debugResult)
  }

  editorInit(edit) {
    require("brace/ext/language_tools")
    require("brace/mode/javascript")
    require("brace/theme/chrome")
    edit.renderer.setPadding(10)
    edit.renderer.setScrollMargin(10)
  }

  select() {
    this.$emit("input", this.textValue)
    this.$emit("change", this.textValue)
    this.modalIsOpen = false
  }

  cancel() {
    this.$emit("input", this.value)
    this.$emit("change", this.value)
    this.textValue = this.value
    this.modalIsOpen = false
  }

  dataAudition() {
    const data = {
      script: this.textValue
    }
    this.http
      .post(`/audition/data?eventID=${this.eventId}&debug`, data)
      .then(res => (this.lastAudition = res.data["$debug"]))
      .catch(this.displayError)
  }

  reduceString(value: any) {
    if (value.length > 50) return value.substring(0, 50) + " ..."
    else return value
  }
}
